var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00019 8.28628L6.02076 6.55371L0.361328 11.4051C0.567042 11.596 0.844757 11.7149 1.15104 11.7149H14.8493C15.1545 11.7149 15.431 11.596 15.6356 11.4051L9.97962 6.55371L8.00019 8.28628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6387 0.595847C15.433 0.403847 15.1564 0.286133 14.849 0.286133H1.15071C0.845567 0.286133 0.568996 0.40499 0.363281 0.598133L7.99985 7.14328L15.6387 0.595847Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.29004V10.7849L5.52343 6.09118L0 1.29004Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4766 6.0907L16 10.7844V1.28613L10.4766 6.0907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic-email.74c861e64d546085a187f171884481c8.svg";
export { ForwardRef as ReactComponent };